<template>
  <div class="input input--text">
    <p v-if="$slots.question" class="input__question">
      <slot name="question"></slot>
      <i class="fas fa-asterisk" v-if="required"></i>
    </p>

    <small class="text-muted input__description" v-if="$slots.description">
      <slot name="description"></slot>
    </small>

    <div class="form-group">
      <template v-if="isMultiline">
        <textarea
          :name="name"
          rows="4"
          class="form-control"
          v-model="model"
          :required="required"
        ></textarea>
      </template>
      <template v-if="!isMultiline">
        <input
          :name="name"
          type="text"
          class="form-control"
          v-model="model"
          :required="required"
          :aria-label="required && alternative_option ? aria_label : null"
        />
      </template>
    </div>

    <slot name="input"></slot>
    
    <p class="form-error" v-if="error" v-text="error" role="alert" aria-live="assertive"></p>
  </div>
</template>


<script setup>
const props = defineProps({
  name: String,
  isMultiline: Boolean,
  value: String,
  error: String,
  required: Boolean,
  alternative_option: Boolean,
  aria_label: String
})
const model = defineModel()
</script>
